import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { BankFormComponent } from "./bank-form/bank-form.component";
import { BankListComponent } from "./bank-list/bank-list.component";

const route:Routes=[
    {  
       path:'',
       data:{
         title:'Bank',
       },
       component:BankListComponent
    },
    {
       path:'add',
       data:{
          title:'New Bank'
       },
       component:BankFormComponent
    },
    {
       path:'edit/:id',
       data:{
          title:'Edit Bank'
       },
       component:BankFormComponent
    }
]


@NgModule({
   imports:[RouterModule.forChild(route)],
   exports:[RouterModule]
})
export class BanKMasterRoutingModule{}